import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import {multipleCommissionAddBankIds} from "util/B2BHelper";

import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Input,
  InputNumber,
  Tooltip,
  Modal,
  Switch,
  DatePicker,
  Checkbox,
} from "antd";
import {
  CalculatorOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const commissionInputProps = {
  style: { width: "calc(100% - 35px)" },
  min: 0,
  max: 100,
  decimalSeparator: ",",
  precision: 2,
  placeholder: "-",
};

const QuestionMarkToolTip = ({ tooltip }) => {
  return (
    <Tooltip title={tooltip}>
      <QuestionCircleOutlined
        className="gx-text-blue"
        style={{ marginRight: 10 }}
      />
    </Tooltip>
  );
};

const PosCollectionCommissionDefinitionAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [calculateCommissionModal, setCalculateCommissionModal] = useState({
    visible: false,
    installmentCount: 2,
  });
  const [isSameRate, setIsSameRate] = useState(false);
  const [form] = Form.useForm();
  const [calculateForm] = Form.useForm();
  const [isUseCreditCardBinCheck, setIsUseCreditCardBinCheck] = useState(false);
  const [cardSelect, setCardSelect] = useState({
    data: [],
    loading: false,
  });
  const [visibleCardSelect, setVisibleCardSelect] = useState(false);
  const [isAgriculturePos, setIsAgriculturePos] = useState(false);
  const [
    useDeferringInstallmentCountRangeBankIds,
    setUseDeferringInstallmentCountRangeBankIds,
  ] = useState([205]);

  const [
    useDeferringInstallmentCountRange,
    setUseDeferringInstallmentCountRange,
  ] = useState(false);

  useEffect(() => {
    getBanks();
    getCardNames();
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsUseCreditCardBinCheck(response.isUseCreditCardBinCheck);
      } else {
        setIsUseCreditCardBinCheck(false);
      }
    });
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/PosCollectionCommissionDefinition/NotAddedBankInfos? $select=id,name,bankName,bankId,isAgriculturePos`
    ).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    if (isSameRate) {
      for (let index = 2; index <= 12; index++) {
        values["commissionRate" + index] = values.installmentCommissionRate;
      }
    }

    if (values.extraInstallmentCount === null) {
      values.extraInstallmentCount = 0;
    }

    RequestHandler.post(`/PosCollectionCommissionDefinition`, values).then(
      (response) => {
        setLoading(false);
        if (response?.success) {
          getBanks();
          form.resetFields();
          onSuccess();
        }
      }
    );
  };

  const renderInstallmentInput = (installmentCount) => {
    return (
      <Form.Item
        label={installmentCount + " Taksit"}
        style={{ marginBottom: 0 }}
        name={"commissionRate" + installmentCount}
      >
        <Input.Group compact>
          <Form.Item noStyle name={"commissionRate" + installmentCount}>
            <InputNumber
              {...commissionInputProps}
              name={"commissionRate" + installmentCount}
              style={{ width: "30%" }}
            />
          </Form.Item>
          <Tooltip title="Hesapla">
            <Button
              type="primary"
              icon={<CalculatorOutlined />}
              onClick={() =>
                setCalculateCommissionModal({
                  visible: true,
                  installmentCount: installmentCount,
                })
              }
            />
          </Tooltip>

          {/* Checkbox Container */}
          <div
            style={{
              flexDirection: "column",
              marginLeft: "5%",
            }}
          >
            {isUseCreditCardBinCheck && (
              <div>
                <Form.Item
                  noStyle
                  valuePropName="checked"
                  name={
                    "commissionRate" + installmentCount + "BusinessCardEnabled"
                  }
                >
                  <Checkbox>Ticari Kart</Checkbox>
                </Form.Item>

                <Form.Item
                  noStyle
                  valuePropName="checked"
                  name={
                    "commissionRate" +
                    installmentCount +
                    "IndividualCardEnabled"
                  }
                >
                  <Checkbox>Bireysel Kart</Checkbox>
                </Form.Item>
              </div>
            )}

            {/* KTD satırı */}
            <div
              style={{
                display: isUseCreditCardBinCheck ? "flex" : "contents",
                alignItems: "center",
                marginTop: "3%",
              }}
            >
              <Form.Item
                noStyle
                valuePropName="checked"
                name={"isCommissionIncludedCommissionRate" + installmentCount}
              >
                <Checkbox name="KTD">KTD</Checkbox>
              </Form.Item>
              <QuestionMarkToolTip
                tooltip={
                  <>
                    <p>
                      <strong>Komisyon Tutara Dahil:</strong>
                      <ul>
                        <li>
                          Bu seçenek aktif edilir ise komisyon tutarı tuşlanan
                          tutarın içine dahil edilir ve kullanıcıya bu yönde
                          bilgi gösterilir.
                        </li>
                      </ul>
                    </p>
                  </>
                }
              />
            </div>
          </div>
        </Input.Group>

        <Input.Group compact style={{ paddingBottom: "20px" }} label="Limit">
          <Form.Item
            label="Alt Limit"
            name={"lowerLimitCommissionRate" + installmentCount}
          >
            <InputNumber
              style={{ width: "100%" }}
              decimalSeparator=","
              precision={2}
              min={0}
              placeholder="0,00"
              maxLength={15}
            />
          </Form.Item>

          <Form.Item
            label="Üst Limit"
            name={"upperLimitCommissionRate" + installmentCount}
          >
            <InputNumber
              style={{ width: "100%" }}
              decimalSeparator=","
              precision={2}
              min={0}
              placeholder="0,00"
              maxLength={15}
            />
          </Form.Item>
        </Input.Group>
      </Form.Item>
    );
  };

  const onCloseModal = () => {
    calculateForm.resetFields();
    setCalculateCommissionModal({
      ...calculateCommissionModal,
      visible: false,
    });
  };

  const onFinishCalculateForm = (values) => {
    const { installmentCount } = calculateCommissionModal;
    const firstCommissionRate = values.firstCommissionRate ?? 0;
    const otherCommissionRates = values.otherCommissionRates ?? 0;

    const formValues = {};
    formValues["commissionRate" + installmentCount] =
      (firstCommissionRate + (installmentCount - 1) * otherCommissionRates) /
      installmentCount;

    form.setFieldsValue(formValues);
    onCloseModal();
  };

  const getCardNames = () => {
    setCardSelect({
      ...cardSelect,
      loading: true,
    });
    RequestHandler.get(`/Card/GetCardNames`).then((response) => {
      setCardSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onChangeBankInfo = (e) => {
    var selectedBank = bankSelect.data.find((x) => x.id === e);
    if (multipleCommissionAddBankIds.includes(selectedBank?.bankId)) {
      setVisibleCardSelect(true);
    } else {
      setVisibleCardSelect(false);
    }

    if (
      selectedBank?.isAgriculturePos &&
      !useDeferringInstallmentCountRangeBankIds.includes(selectedBank?.bankId)
    ) {
      setIsAgriculturePos(true);
    } else {
      setIsAgriculturePos(false);
    }

    if (
      useDeferringInstallmentCountRangeBankIds.includes(selectedBank?.bankId) &&
      selectedBank?.isAgriculturePos
    ) {
      setUseDeferringInstallmentCountRange(true);
    } else {
      setUseDeferringInstallmentCountRange(false);
    }
  };

  return (
    <>
      <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="posCommissionAdd"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={() => setLoading(false)}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="posCollectionBankInfoId"
              label="Banka"
              rules={[{ required: true }]}
            >
              <Select
                allowClear
                showSearch
                placeholder="Seçiniz"
                filterOption={(input, option) =>
                  option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
                loading={bankSelect.loading}
                onChange={onChangeBankInfo}
              >
                {bankSelect.data.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {`${item.bankName} ${item.name ? `- ${item.name}` : ""}`}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {visibleCardSelect && (
              <Form.Item
                name="cardName"
                label="Kart"
                rules={[{ required: true }]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Seçiniz"
                  filterOption={(input, option) =>
                    option.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  loading={cardSelect.loading}
                >
                  {cardSelect.data.map((item) => (
                    <Select.Option key={item} value={item}>
                      {`${item}`}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}

            {!isAgriculturePos && !useDeferringInstallmentCountRange && (
              <Form.Item
                label="Artı Taksit Sayısı"
                name="extraInstallmentCount"
                initialValue={0}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={12}
                  precision={0}
                />
              </Form.Item>
            )}

            {isAgriculturePos && (
              <Form.Item
                label="Erteleme Taksit Sayısı"
                name="deferringInstallmentCount"
                initialValue={0}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={12}
                  precision={0}
                />
              </Form.Item>
            )}

            {useDeferringInstallmentCountRange && (
              <Form.Item label="Erteleme Taksit Sayısı Aralığı">
                <Input.Group compact>
                  <Form.Item
                    label="Başlangıç Taksiti"
                    name="deferringInstallmentCountRangeStartValue"
                    style={{ width: "50%" }}
                    rules={[
                      {
                        validator: async (_, value, callback) => {
                          const start = value;
                          const end = form.getFieldValue(
                            "deferringInstallmentCountRangeEndValue"
                          );

                          if ((start && !end) || (!start && end)) {
                            throw new Error("Her iki alan da doldurulmalıdır.");
                          }

                          if (start && end && start >= end) {
                            throw new Error(
                              "Başlangıç taksiti, bitiş taksitinden küçük olmalıdır."
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <InputNumber min={1} max={12} style={{ width: "100%" }} />
                  </Form.Item>

                  <Form.Item
                    label="Bitiş Taksiti"
                    name="deferringInstallmentCountRangeEndValue"
                    style={{ width: "50%" }}
                    dependencies={["deferringInstallmentCountRangeStartValue"]}
                    rules={[
                      {
                        validator: async (_, value) => {
                          const start = form.getFieldValue(
                            "deferringInstallmentCountRangeStartValue"
                          );
                          const end = value;

                          if ((start && !end) || (!start && end)) {
                            throw new Error("Her iki alan da doldurulmalıdır.");
                          }

                          if (start && end && end <= start) {
                            throw new Error(
                              "Bitiş taksiti, başlangıç taksitinden büyük olmalıdır."
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <InputNumber min={1} max={12} style={{ width: "100%" }} />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            )}

            <Form.Item
              label="Kampanya Bitiş Tarihi"
              name="extraInstallmentExpireDate"
            >
              <DatePicker
                format="DD.MM.YYYY"
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  return moment().add(-1, "days") >= current;
                }}
              />
            </Form.Item>

            <Form.Item name="commissionRate1" label="Tek Çekim">
              <Input.Group compact>
                <Form.Item name="commissionRate1">
                  <InputNumber
                    {...commissionInputProps}
                    style={{ width: "90%" }}
                  />
                </Form.Item>
                <div
                  style={{
                    flexDirection: "column",
                  }}
                >
                  {isUseCreditCardBinCheck && (
                    <div>
                      <Form.Item
                        noStyle
                        valuePropName="checked"
                        name="commissionRate1BusinessCardEnabled"
                      >
                        <Checkbox name="ticariKart">Ticari Kart</Checkbox>
                      </Form.Item>

                      <Form.Item
                        noStyle
                        valuePropName="checked"
                        name="commissionRate1IndividualCardEnabled"
                      >
                        <Checkbox name="bireyselKart">Bireysel Kart</Checkbox>
                      </Form.Item>
                    </div>
                  )}
                  <div
                    style={{
                      display: isUseCreditCardBinCheck ? "flex" : "contents",
                      alignItems: "center",
                      marginTop: "3%",
                    }}
                  >
                    <Form.Item
                      noStyle
                      valuePropName="checked"
                      name="isCommissionIncludedCommissionRate1"
                    >
                      <Checkbox name="KTD">KTD</Checkbox>
                    </Form.Item>
                    <QuestionMarkToolTip
                      tooltip={
                        <>
                          <p>
                            <strong>Komisyon Tutara Dahil:</strong>
                            <ul>
                              <li>
                                Bu seçenek aktif edilir ise komisyon tutarı
                                tuşlanan tutarın içine dahil edilir ve
                                kullanıcıya bu yönde bilgi gösterilir.
                              </li>
                            </ul>
                          </p>
                        </>
                      }
                    />
                  </div>
                </div>
              </Input.Group>

              <Input.Group compact style={{ paddingBottom: "20px" }}>
                <Form.Item label="Alt Limit" name="lowerLimitCommissionRate1">
                  <InputNumber
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    precision={2}
                    min={0}
                    placeholder="0,00"
                    maxLength={12}
                  />
                </Form.Item>

                <Form.Item label="Üst Limit" name="upperLimitCommissionRate1">
                  <InputNumber
                    style={{ width: "100%" }}
                    decimalSeparator=","
                    precision={2}
                    min={0}
                    placeholder="0,00"
                    maxLength={12}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>

            <Form.Item
              label="Taksitli İşlemler Sabit Oran"
              valuePropName="checked"
            >
              <Switch onChange={setIsSameRate} />
            </Form.Item>

            {isSameRate ? (
              <Form.Item
                label="Taksitli İşlem"
                name="installmentCommissionRate"
              >
                <InputNumber
                  {...commissionInputProps}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            ) : (
              <>
                {renderInstallmentInput(2)}
                {renderInstallmentInput(3)}
                {renderInstallmentInput(4)}
                {renderInstallmentInput(5)}
                {renderInstallmentInput(6)}
                {renderInstallmentInput(7)}
                {renderInstallmentInput(8)}
                {renderInstallmentInput(9)}
                {renderInstallmentInput(10)}
                {renderInstallmentInput(11)}
                {renderInstallmentInput(12)}
              </>
            )}

            <Form.Item label="Açıklama" name="description">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col></Col>
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Row>
      </Form>

      <Modal
        id="calculateCommissionModal"
        title={`${calculateCommissionModal.installmentCount} Taksit Komisyon Hesaplama`}
        centered
        visible={calculateCommissionModal.visible}
        onOk={onCloseModal}
        onCancel={onCloseModal}
        width={600}
        footer={null}
      >
        <Form
          {...formItemLayout}
          validateMessages={defaultValidateMessages}
          form={calculateForm}
          name="calculateForm"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinishCalculateForm}
        >
          <Row>
            <Col span={24}>
              <Form.Item label="İlk Taksit" name="firstCommissionRate">
                <InputNumber {...commissionInputProps} placeholder="0,00" />
              </Form.Item>

              <Form.Item
                label="Sonraki Taksit(ler)"
                name="otherCommissionRates"
              >
                <InputNumber {...commissionInputProps} placeholder="0,00" />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col></Col>
            <Col>
              <Button
                type="primary"
                icon={<CalculatorOutlined />}
                htmlType="submit"
              >
                Hesapla
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
export default PosCollectionCommissionDefinitionAddForm;
